import React from 'react'
import { StarRatingIcon } from '@/atoms/Icons/StarRatingIcon'

interface StarRatingInputProps {
  value: number | null
  onChange: (rating: number) => void
  ariaLabel?: string
}

export const StarRatingInput: React.FC<StarRatingInputProps> = ({ value, onChange, ariaLabel = 'Rating' }) => {
  return (
    <div className="flex" role="radiogroup" aria-label={ariaLabel}>
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          className="flex h-10 w-10 items-center justify-center"
          onClick={() => onChange(star)}
          aria-label={`${star} star${star > 1 ? 's' : ''}`}
          aria-checked={value === star}
          role="radio"
        >
          <StarRatingIcon size={32} variant={value !== null && star <= value ? 'filled' : 'empty'} />
        </button>
      ))}
    </div>
  )
}
